import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { UserInfoStyled } from "./styled";
import moment from "moment";
import { useTranslation } from "react-i18next";
import BtnEmailUpdateWidget from "widgets/BtnEmailUpdateWidget";
import { ProfileUpdateWidget } from "widgets";

const UserInfo = ({ theme_standard, data, onEdit }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const { t, i18n } = useTranslation(["profile", "common"]);

  return (
    <UserInfoStyled lang={i18n.language}>
      <div className={customClass}>
        <div className="user_info_container">
          <div className="title">{t("My Profile", { ns: "common" })}</div>
          <div className="ui_row">
            <div className="ui_label">{t("First name", { ns: "profile" })}</div>
            <div className="ui_value">
              <span className="ui_text">{`${data.first_name}`}</span>
              {onEdit && <BtnEmailUpdateWidget type="first_name" />}
            </div>
          </div>
          <div className="ui_row">
            <div className="ui_label">{t("Last name", { ns: "profile" })}</div>
            <div className="ui_value">
              <span className="ui_text">{`${data.last_name}`}</span>
              {onEdit && <BtnEmailUpdateWidget type="last_name" />}
            </div>
          </div>
          <div className="ui_row">
            <div className="ui_label">
              {t("Mobile number", { ns: "profile" })}
            </div>
            <div className="ui_value">
              <span className="ui_text">{data.phone_number}</span>
              {onEdit && <BtnEmailUpdateWidget type="phone_number" />}
            </div>
          </div>
          <div className="ui_row">
            <div className="ui_label">{t("Address", { ns: "profile" })}</div>
            <div className="ui_value"><span className="ui_text">{data.province}</span></div>
          </div>
          <div className="ui_row">
            <div className="ui_label">
              {t("Date of Birth", { ns: "profile" })}
            </div>
            <div className="ui_value">
              <span className="ui_text">{moment(data.birthday).format("DD MMMM YYYY")}</span>
            </div>
          </div>
          <div className="ui_row mb_32">
            <div className="ui_label">{t("Email", { ns: "profile" })}</div>
            <div className="ui_value">
              {onEdit ? (
                <><span className="ui_text">{data.email ? data.email : ""}</span>{!data.email && <BtnEmailUpdateWidget />}</>
              ) : (
                <span className="ui_text">{data.email ? data.email : "-"}</span>
              )}
            </div>
          </div>
        </div>
        <div className="btn_wrap">
          <ProfileUpdateWidget data={data} />
        </div>
      </div>
    </UserInfoStyled>
  );
};

UserInfo.propTypes = {};

export default UserInfo;
